import type { WaterPhaseVolumeFactorBwCalculator } from "../d";
import {
  calculateBrineWaterDensity,
  calculateEb,
  calculateFb,
  calculateFbCompressibility,
  calculateMolarSaltConcentration,
  calculatePbwAt70Mpa,
  calculatePureWaterCompressibility,
  calculatePureWaterDensity,
  calculateVbo,
  calculateWaterVolumeFactor,
  calculatelbAt70Mpa,
  calculatelbAtStockTank,
  calculatelw0At70Mpa,
  calculatelwAtStockTank,
  pwAt70Mpa,
  EwoVar,
  FwoVar,
  Dm2Var,
  Dm32Var,
  Dm1Var,
  Dm12Var,
  EmVar,
  Fm32Var,
  Fm1Var,
  Fm12Var
} from "./helpers";
export const waterPhaseVolumeFactorBwCalculator: WaterPhaseVolumeFactorBwCalculator =
  params => {
    const { salinity_ppm } = params;

    const v = 0.997339256;
    const stockTankPressurePo = 0.1013529;
    const molarSaltConcentration =
      calculateMolarSaltConcentration(salinity_ppm);

    const Cwo = calculatePureWaterCompressibility(
      stockTankPressurePo,
      EwoVar,
      FwoVar
    );

    const lw70Mpa = calculatelw0At70Mpa(EwoVar, FwoVar);
    const lwStockTank = calculatelwAtStockTank(
      stockTankPressurePo,
      EwoVar,
      FwoVar
    );

    const pureWaterDensity = calculatePureWaterDensity(
      pwAt70Mpa,
      lwStockTank,
      lw70Mpa
    );

    const pbwAt70Mpa = calculatePbwAt70Mpa(
      pwAt70Mpa,
      Dm2Var,
      Dm32Var,
      Dm1Var,
      Dm12Var,
      molarSaltConcentration
    );

    const Eb = calculateEb(EwoVar, EmVar, molarSaltConcentration);
    const Fb = calculateFb(
      FwoVar,
      Fm32Var,
      Fm1Var,
      Fm12Var,
      molarSaltConcentration
    );

    const FbCompressibility = calculateFbCompressibility(
      stockTankPressurePo,
      Eb,
      Fb
    );

    const lb70Mpa = calculatelbAt70Mpa(Eb, Fb);
    const lbStockTank = calculatelbAtStockTank(stockTankPressurePo, Eb, Fb);

    const brineWaterDensity = calculateBrineWaterDensity(
      pbwAt70Mpa,
      lbStockTank,
      lb70Mpa
    );

    const Vbo = calculateVbo(brineWaterDensity);
    const waterVolumeFactorBBLSTB = calculateWaterVolumeFactor(v, Vbo);

    return {
      waterVolumeFactorBBLSTB,
      pureWaterDensity,
      brineWaterDensity,
      EwoVar,
      FwoVar,
      Cwo,
      FbCompressibility,
      lb70Mpa,
      lbStockTank,
      pbwAt70Mpa,
      Vbo
    };
  };
